export function getCertificates(data) {
  const allCertificates = [];
  const c = data.acf.reader_profile_certificates;

  if (c === null) {
    return;
  }

  c.map((e) => allCertificates.push(e.reader_profile_certificates_name));
  return allCertificates.join(', ');
}
